import { CountryCodeByAppDomain } from '@pegasus/config';
export const getNow = () => Math.floor(Date.now() / 1000);
export const buildItemName = (item) => {
    let name = '';
    name += item.additionalName ? `${item.additionalName} - ` : '';
    name += item.nameCategoryTag ? `${item.nameCategoryTag} - ` : '';
    name += item.nameColor;
    return name;
};
function priceToCents(priceAsString) {
    return Number(priceAsString) * 100;
}
function calculateShippingCosts(cartItems) {
    return cartItems.reduce((accumulator, { appDomainId, shippingCosts }) => {
        const countryCode = CountryCodeByAppDomain[appDomainId];
        const shippingCost = shippingCosts[countryCode];
        const shippingCostInCents = priceToCents(shippingCost);
        return Math.max(shippingCostInCents, accumulator);
    }, 0);
}
export const transformCart = (cart) => ({
    savings: cart.items.reduce((result, item) => result + (item.price.suggestedRetailPrice - item.price.grossRetailPrice), 0),
    total: cart.items.reduce((result, item) => result + item.price.grossRetailPrice, 0),
    expiresIn: cart.remainingLifetimeSeconds,
    expiresAt: Math.floor(new Date().getTime() / 1000) + cart.remainingLifetimeSeconds,
    shippingCosts: calculateShippingCosts(cart.items),
    items: cart.items.map((item) => ({
        brand: item.brand,
        configSku: item.configSku,
        simpleSku: item.simpleSku,
        imageUrl: item.imageUrl,
        campaignIdentifier: item.campaignIdentifier,
        url: item.articleUrl[item.appDomainId],
        name: buildItemName(item),
        size: item.size,
        price: item.price.grossRetailPrice,
        grossRecommendedRetailPrice: item.price.suggestedRetailPrice,
        grossRetailPrice: item.price.grossRetailPrice,
        brandCode: item.brandCode,
        nameColor: item.nameColor,
        nameCategoryTag: item.nameCategoryTag || '',
        reco: item.additional && item.additional.reco,
        gender: item.gender,
        deliveryPromiseType: item.eventOptions ? item.eventOptions.deliveryPromiseType : '',
        deliveryPromise: {
            beginDate: item.delivery_promise.begin_date,
            endDate: item.delivery_promise.end_date,
            specialDeliveryPromiseType: item.delivery_promise.special_delivery_promise_type,
        },
        deliveryDateFrom: item.deliveryDateFrom,
        deliveryDateTo: item.deliveryDateTo,
        reservationId: item.reservationId,
        plusEarlyAccess: item.plusEarlyAccess,
    })),
});
export const track = (event, payload = {}) => {
    if (typeof window === 'undefined') {
        return;
    }
    const trackingInfo = { event, ...payload };
    return window.dataLayer && window.dataLayer.push(trackingInfo);
};
//# sourceMappingURL=helpers.js.map